import type { TClass, TFaseGroup } from 'types/classAndPhases'

const kelasSD: TClass[] = [
  'Kelas 1',
  'Kelas 2',
  'Kelas 3',
  'Kelas 4',
  'Kelas 5',
  'Kelas 6',
]
const kelasSMP: TClass[] = ['Kelas 7', 'Kelas 8', 'Kelas 9']
const kelasSMA: TClass[] = ['Kelas 10', 'Kelas 11', 'Kelas 12']

type TJenjangSekolah = {
  [jenjang: string]: {
    kelas: TClass[]
    type: TFaseGroup
  }
}

export const jenjangKelasMapping: TJenjangSekolah = {
  PAUD: {
    kelas: ['PAUD'],
    type: 'Umum',
  },
  SD: {
    kelas: kelasSD,
    type: 'Umum',
  },
  SDLB: {
    kelas: kelasSD,
    type: 'SLB',
  },
  SMP: {
    kelas: kelasSMP,
    type: 'Umum',
  },
  SMPLB: {
    kelas: kelasSMP,
    type: 'SLB',
  },
  SMA: {
    kelas: kelasSMA,
    type: 'Umum',
  },
  SMK: {
    kelas: kelasSMA,
    type: 'SMK',
  },
  SMALB: {
    kelas: kelasSMA,
    type: 'SLB',
  },
}
